import React from 'react';
import {
  render,
  RenderOptions,
  NODE_PARAGRAPH,
  MARK_LINK,
  NODE_HEADING,
} from 'storyblok-rich-text-react-renderer';
import merge from 'lodash/merge';
import { StoryblokRichText } from 'types/Storyblok';
import { Link, Typography } from '@mui/material';

export default function renderRichText(
  document: StoryblokRichText,
  options?: RenderOptions
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  const defaultOptions: RenderOptions = {
    markResolvers: {
      [MARK_LINK]: linkResolver,
    },
    nodeResolvers: {
      [NODE_PARAGRAPH]: paragraphResolver,
      [NODE_HEADING]: headingResolver,
    },
  };
  const mergedOptions = merge(defaultOptions, options);
  return render(document, mergedOptions);
}

function paragraphResolver(children: React.ReactNode): React.ReactElement {
  return <Typography>{children}</Typography>;
}

function headingResolver(
  children: React.ReactNode,
  { level }: { level: 1 | 2 | 3 | 4 | 5 | 6 }
): React.ReactElement {
  const variant = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  return <Typography variant={variant}>{children}</Typography>;
}

function linkResolver(
  children: React.ReactNode,
  props: {
    linktype?: string;
    href?: string;
    target?: string;
    anchor?: string;
    uuid?: string;
  }
): React.ReactElement {
  const muiProps = props
    ? {
        href: props.linktype === 'email' ? `mailto:${props.href}` : props.href,
        target: props.target,
      }
    : {};
  return <Link {...muiProps}>{children}</Link>;
}
